import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import athletesGreenIcon from "../../assets/images/athletes.svg";
import athletesWhiteIcon from "../../assets/images/athletes-white.svg";
import { Link, useNavigate } from "react-router-dom";
import 'moment/locale/es';
import { getAthlete } from "../../services/athlete";
import { Athlete, AthleteTeamSeason } from "../../interfaces/athlete";
import { getSeasonCurrent } from "../../services/season";
import { LoadingSpinner } from "../general/loading-spinner";
import { UserContext } from "../../App";
import { Figure } from "react-bootstrap";

export function AthletesMini() {
    const navigate = useNavigate();

    const { userProfile } = useContext(UserContext);

    const [athletes, setAthletes] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getSeasonCurrent()
            .then(response => {
            if (response.data.id !== undefined) {
                getAthlete('', '', '', response.data.id)
                    .then(responseAthlete => {
                        setAthletes(responseAthlete.data);
                        setLoaded(true);
                    });
            } 
        })
        .catch(error => {
            localStorage.removeItem('token');
            navigate("/");
        });
    }, []);

    return (
        <div className="block block-athletes-mini">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ athletesGreenIcon } alt={ t("athletes")} />
                    { t("athletes") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        <div className="block-content-inner">
                            <div className="block-content-data">
                                { !loaded && <LoadingSpinner /> }
                                { loaded &&
                                    athletes.slice(0, 10).map((a: Athlete) => {
                                        return (<div key={ 'athlete-' + a.id } className="athlete-tile">
                                                <div className="icon">
                                                    { a.avatar.length > 0 &&
                                                        <Figure.Image src={ a.avatar[0].src } alt={ a.avatar[0].name } width={50} height={50} />
                                                    }
                                                </div>
                                                <div className="title">
                                                    <Link to={ '/athletes/' + a.id + '/view' }  title={ a.name }>
                                                        { a.name }
                                                    </Link>
                                                    { a.registered_in.length > 0 &&
                                                        <div className="teams">
                                                            {
                                                                a.registered_in.map((ats: AthleteTeamSeason) => {
                                                                    return ats.club_name + '/' + ats.team_name;
                                                                }).join(', ')
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>)
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className="block-footer">
                    { userProfile.role.filter((r: any) => r.id == 'badminton_administrator').length > 0 &&
                        <Link to="/admin/athletes" title={ t("athletes") } className="btn btn-primary">
                            <img src={ athletesWhiteIcon } alt={ t("athletes")} /> { t("athletes") }
                        </Link>
                    }
                    { userProfile.role.filter((r: any) => r.id == 'badminton_manager').length > 0 &&
                        <Link to="/manager/athletes" title={ t("athletes") } className="btn btn-primary">
                            <img src={ athletesWhiteIcon } alt={ t("athletes")} /> { t("athletes") }
                        </Link>
                    }
                </div>
            </div>
        </div>
    );
}  
